import { useId, type ReactNode } from 'react'
import { Drawer } from '@/components/ds2'

interface PanelDrawerProps {
    open?: boolean
    onClose: () => void
    title: string
    subtitle?: ReactNode
    footer: ReactNode
    children: ReactNode
}

/**
 * The invoicing chat's one review panel (v17 `.drawer`): fixed to the right, 650px wide (the full width on a narrow screen), the full
 * height, a heading with its title, subtitle and ×, a scrolling body and an action bar at the foot, over a dimmed, blurred backdrop.
 * Esc and a backdrop click close it. Every review the chat opens (load review, document, draft, emails, factoring batch) uses it.
 */
export const PanelDrawer = ({ open = true, onClose, title, subtitle, footer, children }: PanelDrawerProps) => {
    const titleId = useId()
    return (
        <Drawer
            open={open}
            onClose={onClose}
            position="right"
            width={650}
            divided
            ariaLabelledBy={titleId}
            heading={
                <div className="flex flex-col gap-1">
                    <h2 id={titleId} className="text-lg font-semibold text-foreground">
                        {title}
                    </h2>
                    {subtitle && <p className="text-sm text-foreground-muted">{subtitle}</p>}
                </div>
            }
            footer={<div className="flex flex-wrap justify-end gap-2">{footer}</div>}
        >
            {children}
        </Drawer>
    )
}
